// Botão de "modo organizar" — liga/desliga o arrasto de pastas/itens.
//
// Motivo (Luís 2026-05-27): no mobile o usuário arrastava blocos sem querer ao
// tentar deslizar a tela (os cards tinham touch-action:none pro dnd-kit). Com o
// arrasto desligado por padrão, o scroll por toque volta ao normal; ligando o
// modo, o arrasto fica disponível. Vale pra desktop e mobile (decisão do user).
//
// O estado NÃO persiste entre recarregamentos de propósito: a tela sempre abre
// "segura" (sem arrasto), evitando que o mobile volte a arrastar sem querer.

import { Check, Move } from "lucide-react";

export function OrganizeToggle({
  active,
  onToggle
}: {
  active: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={active}
      title={
        active
          ? "Arrasto ativado — toque pra concluir e voltar a deslizar a tela"
          : "Ativar arrasto pra reorganizar pastas e bancos"
      }
      class={`inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-xs font-semibold transition-colors ${
        active
          ? "border-violet-500 bg-violet-500 text-white shadow-sm"
          : "border-border bg-background text-foreground hover:border-primary hover:bg-accent"
      }`}
    >
      {active ? <Check className="size-3.5" /> : <Move className="size-3.5" />}
      {active ? "Concluir" : "Organizar"}
    </button>
  );
}
